import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

function CheapRadios({ data }) {

  const {area_name, area_name_full} = data

  const images = useStaticQuery(graphql`
      query {
          cheapRadios: file(relativePath: {eq: "commusa-cheap-two-way-radios.jpg"}) {
              childImageSharp {
                  fluid {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
      }
  `)

  return (
    <div className="container py-3" id="cheap-radios">
      <div className="row">
        <div className="col-12">
          <h2>Cheap Two-Way Radios for Sale in {area_name}</h2>
          <p>Today, many organizations in {area_name_full} rely on mobile phones to stay connected. Yet, when you need a
            cheaper, more reliable method of communication, cell phones just won’t cut it— you need an inexpensive
            two-way radio system from CommUSA.</p>
          <p>Our entry-level two-way radios provide a lower total cost of ownership than cell phones. You don’t have to
            pay for service or data, and training costs are virtually non-existent. Plus, with restrictions on who your
            employees can reach out to, you’re ensuring a more productive workforce. When time equals money, that’s
            hundreds to thousands of dollars saved each year.</p>
          <p>Best of all these radios are small, lightweight and simple to use. They’re suited for retail spaces, places
            of worship like churches, synagogues, mosques and temples, apartment complexes, contractor and builder
            sites, offices, small commercial buildings, small distribution centers, restaurants, night clubs, motels,
            small hotels and more. Whether you offer curbside pickup to your customers or simply need a fast, efficient
            way to communicate to the back of your store or restaurant, our collection of Motorola Two-Way radios are
            perfect for your team.</p>
          <div className="row">
            <div className="col-12 col-lg-6">
              <p>We offer the largest selection of value-priced portable two-way radios for sale and rent
                in {area_name_full}, including:</p>
              <ul className="p">
                <li>CLP1010</li>
                <li>CLP1040</li>
                <li>CLP1060</li>
                <li>CLS1110</li>
                <li>CLS1410</li>
                <li>DLR1020</li>
                <li>DLR1060</li>
                <li>DTR600</li>
                <li>DTR700</li>
                <li>RDU4160E</li>
                <li>RDV5100</li>
                <li>RMM2050</li>
                <li>RMU2040</li>
                <li>RMU2080</li>
                <li>RMU2080D</li>
                <li>RMV2080</li>
              </ul>
            </div>
            <div
              className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-center order-first order-lg-last mb-3">
              <Img className="w-100" fluid={images.cheapRadios.childImageSharp.fluid}
                   alt="CommUSA - Cheap Two-Way Radios" style={{ maxWidth: "500px" }}/></div>
          </div>
          <p>All of these Motorola light-duty two-way radio models are compact and contain only those features you need
            for short, rapid communication. That’s why we can offer them to you at a lower price point.</p>
          <p>Don’t let that fool you into thinking you’re getting anything less than the best customer service from
            CommUSA. We always guarantee the same incredible service, whether you’re purchasing, renting, or taking
            advantage of our incredible deals on two-way radios.</p>
          <p>If value matters most to your {area_name_full} business, we have an inexpensive portable two-way radio for
            your needs. Check out our high-value models now and start saving with a two-way radio communication system
            from CommUSA!</p>
          <div className="btn-group" role="group">
            <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
              className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                        href="https://www.commusa.com/contact-us">Request
            Quote</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CheapRadios
